var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('preview',{ref:"preview",attrs:{"id":"preview-schedule","is-preview":true,"schedule-manager":_vm.scheduleManager,"show":_vm.showPreview}})],1),_c('v-row',{attrs:{"id":"textRenderingToCanvas"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }